/**
 * Storeについて
 * 
 * - ルール
 * 		- 共通で使用するものはstore.jsに記述
 * 		- 画面別またはモジュール別に関しては、state/module以下に作成
 * 			→ファイル名は半角英字とハイフン、アンダーバーのみ許可。
 * 			→現在はページごとにディレクトリを作成している。
 * 			※module以下のjsは自動読み込みされます。
 * 		→モジュールには「namespaced: true」を指定してください。
 * 			※ファイル名がそのままモジュール名として使用される。
 * 			例) store/modules/account/account.js → account
 * 		- Storeに直接アクセスされないようStoreAccessorにも定義する。
 * 		  ./storeAccessor参照
 * 
 * - 使用方法
 * 		- Storeアクセス時は必ずstoreAccessorを用いる。
 * 			import { storeAccessor } from './store/storeAccessor';
 * 			storeAccessor.storeMethod(args);
 * 
 */
//import Vue from 'vue';
//import Vuex from 'vuex';
import { createStore } from 'vuex'
//Vue.use(Vuex);

/**
 * ストアモジュールを読み込む
 */
const loadModules = () => {
	// ストア定義全取得
	let context = null;
	try{
		context = require.context("./modules", true, /([a-z_-]+)\.js$/i);
	} catch(e){
		// エラー処理はしない
		// modulesにファイルが一つもない場合に、git管理的にはmodulesフォルダ自体が削除される
		// その結果modulesのストア定義読み込み時にエラーとなる。
	}
	const modules = {};

	if(context){
		// ストア定義を格納 ( 例: {account: "..."} 定義のキーは拡張子を除いたファイル名)
		context.keys().forEach(key => {
			let storeName = key.match(/([a-z_-]+)\.js$/i)[1];
			modules[storeName] = context(key).default;
		});
	}
	return modules;
}

// ストアモジュール格納
const modules = loadModules();

/**
 * Storeを生成
 */
const store = createStore({
	// 全モジュール読み込み
	modules,
	// 共通ストア
	state: {
		/** トークン情報 */
		token: null,
		/** ユーザー情報 */
		user: null,
		/** ローディングフラグ */
		isLoading: false,
		/** ローディングオーバーレイ使用フラグ */
		useLoadingOverlay: true,
	},
	mutations: {
		/**
		 * ストアの初期化
		 * @param {*} state 管理データ
		 */
		initVuexState: state => {
			state.isLoading = false,
			state.token = null,
			state.useLoadingOverlay = true
		},
		/**
		 * ローディングフラグを設定します。
		 * @param {*} state 管理データ
		 * @param {*} isLoading ローディングフラグ
		 */
		setIsLoading: (state, isLoading) => {
			state.isLoading = isLoading;
		},
		/**
		 * トークン情報を設定します。
		 * @param {*} state 管理データ
		 * @param {*} token トークン
		 */
		setToken: (state, token) => {
			state.token = token;
		},
		/**
		 * ユーザー情報を設定します。
		 * @param {*} state 管理データ
		 * @param {*} user ユーザー情報
		 */
		setUser: (state, user) => {
			state.user = user;
		},
		/**
		 * ローディングオーバーレイ使用フラグを設定します。
		 * @param {*} state 管理データ
		 * @param {*} useLoadingOverlay ローディングオーバーレイ使用フラグ
		 */
		setUseLoadingOverlay: (state, useLoadingOverlay) => {
			state.useLoadingOverlay = useLoadingOverlay;
		},
	},
	getters: {
		/**
		 * ローディングフラグを取得します。
		 * @param {*} state 管理データ
		 * @return ローディングフラグ
		 */
		getIsLoading: state => {
			return state.isLoading;
		},
		/**
		 * トークン情報を取得します。
		 * @param {*} state 管理データ
		 * @return トークン情報
		 */
		getToken: state => {
			return state.token;
		},
		/**
		 * ユーザー情報を取得します。
		 * @param {*} state 管理データ
		 * @return ユーザー情報
		 */
		getUser: state => {
			return state.user;
		},
		/**
		 * ローディングオーバーレイ使用フラグを取得します。
		 * @param {*} state 管理データ
		 * @returns ローディングオーバーレイ使用フラグ
		 */
		getUseLoadingOverlay: state => {
			return state.useLoadingOverlay;
		},
	}
});
export default store;